export default {
  title: 'Modifier le profil de {{name}}',
  form: {
    name: {
      label: 'Nom',
      placeholder: 'Saisir le nom complet du propriétaire',
    },
    email: {
      label: 'E-mail',
      placeholder: "Saisir l'e-mail personnel du propriétaire",
      tooltip: 'E-mail personnel du propriétaire/gestionnaire. Utilisé comme identifiant du tableau de bord',
    },
  },
  buttons: {
    save: 'Enregistrer',
  },
  toasts: {
    failed_to_save_changes: "Échec de l'enregistrement des modifications",
    changes_got_saved: 'Modifications enregistrées',
  },
};
